module.exports = __webpack_public_path__ + "img/battery-medium.4e1526e4.svg";